export const environment = {
  production: false,
  apiUrl : 'https://mycoop.com/api/',
  // apiUrl: 'https://test.mycoop.com/api/',
  clientUrl: 'https://mycoop.com/',
  socketUrl: 'https://mycoop.com/',

  facebook: {
    appId: "262874930884852",
    xfbml: true,
    version: "v5.0",
  },
  s3BucketApi: "https://mycooplive.s3.amazonaws.com/",
  amount: 40,
  stripeKey: "pk_live_egKxfW9i7EiA5zdW0inAYIEg",
  stripeMode: "production",
  // stripeKey: "pk_test_51SpWwqPAWp69biZtLAl8sCnhBjVTnavTSVSDs1d7XmjmvLh4PlmmZ1ZohCB6y7z3JLBMmMqc15PpvJuyp7Kwzerz00pQwmhGug",
  // stripeMode: "sandbox",
  googleMapsApiKey: "AIzaSyALgww4BoKkilECCT-1r4I5w_Dv103uGAM",
};
